export const Events = {
  CREATE_NOTIFICATION: 'CREATE_NOTIFICATION',
  DELETE_NOTIFICATION: 'DELETE_NOTIFICATION',
  CREATE_NOTIFICATION_REQUEST: 'CREATE_NOTIFICATION_REQUEST',
  DELETE_NOTIFICATION_REQUEST: 'DELETE_NOTIFICATION_REQUEST',
  CREATE_MESSAGE: 'CREATE_MESSAGE',
  SEND_MESSAGE: 'SEND_MESSAGE',
  REQUEST_USER_SOCKET_ID: 'REQUEST_USER_SOCKET_ID',
  SEND_USER_SOCKET_ID: 'SEND_USER_SOCKET_ID',
  SIGNAL: 'SIGNAL',
  CALL_USER: 'CALL_USER',
  ACCEPT_CALL: 'ACCEPT_CALL',
  CALL_ACCEPTED: 'CALL_ACCEPTED',
};
